import { all, put, call, takeLatest } from 'redux-saga/effects';
import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'

export default function* fetchAdapter() {

	yield all([
		takeLatest(actions.FETCH_GET_ADAPTER_LIST_REQUEST, getAdapterList),
		takeLatest(actions.FETCH_GET_ADAPTER_SETTING_REQUEST, getAdapterDetail),

		takeLatest(actions.FETCH_SET_ADAPTER_REGISTER_REQUEST, setAdapterRegister),
		takeLatest(actions.FETCH_SET_ADAPTER_UNREGISTER_REQUEST, setAdapterUnresiter),
		takeLatest(actions.FETCH_SET_ADAPTER_UPDATE_REQUEST, setAdapterUpdate),
		takeLatest(actions.FETCH_SET_ADAPTER_ENABLE_REQUEST, setAdapterEnable),

		takeLatest(actions.FETCH_SET_ADAPTER_STORAGE_REQUEST, setAdapterStorage),
		takeLatest(actions.FETCH_SET_ADAPTER_PARAMS_REQUEST, setAdapterParams),
		takeLatest(actions.FETCH_SET_ADAPTER_ROOTPATH_REQUEST, setAdapterRootPath),
	])
}

function* getAdapterList() {
	try {
		const result = yield call(api.getAdapterList)
		
		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_ADAPTER_LIST_SUCCESS,
				value: result.data.value,
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_ADAPTER_LIST_FAILURE
		})
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* getAdapterDetail(params){
	try {
		const result = yield call(api.getAdapterDetail, params)

		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_ADAPTER_SETTING_SUCCESS,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_GET_ADAPTER_SETTING_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setAdapterRegister(params){
	try{
		const result = yield call(api.setAdapterRegister, params)
		
		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
			yield put({
				type: actions.SET_ADAPTER_REGISTER_ERRORLABEL,
				errorLabel: result.data.errorLabel
			})
		}
		else {
			//file_input reset
			params.target.reset();
			document.getElementById('label_file').innerText = null;

			yield put({
				type: actions.SET_ADAPTER_REGISTER_MODAL,
			})

			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})

			//reload
			yield put({
				type: actions.FETCH_GET_ADAPTER_LIST_REQUEST
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_SET_ADAPTER_REGISTER_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setAdapterUnresiter(params){
	try {
		const result = yield call(api.setAdapterUnresiter,params)
		
		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		}
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.deleted",
				isError: false
			})
			//realod
			yield put({
				type: actions.FETCH_GET_ADAPTER_LIST_REQUEST,
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_SET_ADAPTER_UNREGISTER_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})

	}
}

function* setAdapterUpdate(params){
	try{
		const result = yield call(api.setAdapterUpdate,params)
		
		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
			
			yield put({
				type: actions.SET_ADAPTER_UPDATE_ERRORLABEL,
				errorLabel: result.data.errorLabel
			})
		}
		else {
			//file_input reset
			params.target.reset();
			document.getElementById('label_update_file').innerText = null;

			yield put({
				type: actions.SET_ADAPTER_UPDATE_MODAL
			})

			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})

			//reload
			yield put({
				type: actions.FETCH_GET_ADAPTER_LIST_REQUEST
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_SET_ADAPTER_UPDATE_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setAdapterEnable(params){
	try {
		const result = yield call(api.setAdapterEnable,params)

		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: result.data.messageId,
				isError: true
			})
		}
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})
			yield put({
				type: actions.FETCH_GET_ADAPTER_LIST_REQUEST
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_SET_ADAPTER_ENABLE_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* setAdapterStorage(params){
	try {
		const result = yield call(api.setAdapterStorage,params)
		
		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.SET_ADAPTER_SETTING_ERRORLABEL,
				errorLabel: {storageName:result.data.errorLabel}
			})
		}
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_SET_ADAPTER_STORAGE_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})

	}
}

function* setAdapterParams(params){
	try {
		const result = yield call(api.setAdapterParams,params)

		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.SET_ADAPTER_SETTING_ERRORLABEL,
				errorLabel: {paramsName:result.data.messageId}
			})
		}
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved.",
				isError: false
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_SET_ADAPTER_PARAMS_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})

	}
}

function* setAdapterRootPath(params){
	try {
		const result = yield call(api.setAdapterRootPath,params)

		yield put({ type: actions.FETCH_ADAPTER_ERROR_SUCCESS })
		
		if (result.data.resultCode > 0) {
			yield put({
				type: actions.SET_ADAPTER_SETTING_ERRORLABEL,
				errorLabel: {rootPath:result.data.errorLabel}
			})
		}
		else {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved.",
				isError: false
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		//FETCH_SET_ADAPTER_ROOTPATH_FAILURE
		yield put({
			type: actions.FETCH_ADAPTER_ERROR_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})

	}
}

